// Ritorna il valore di `key` comune a tutti i membri di un gruppo (es. id_autista),
// o null se il gruppo è vuoto, il primo membro non ha valore, o i membri non concordano.
// Stessa convenzione già usata da checkSameStatus in TripGroup/logic/useTripGroup.js.
// Nessuna dipendenza esterna: file "foglia" per evitare cicli di import (usato
// sia da `ordersLogic.js` sia direttamente da `modules/utils.jsx`, che
// `ordersLogic.js` a sua volta importa).
export function getUnanimousValue(members, key) {
  if (!Array.isArray(members) || members.length === 0) return null;
  const first = members[0]?.[key];
  if (!first) return null;
  return members.every((m) => m?.[key] === first) ? first : null;
}
